const { NODE_ENV } = process.env

export interface FeatureFlagsType {
  isAccountDetailsRouteEnabled: boolean
  isAccountUpgradingMessageEnabled: boolean
  isAddAccountEnabled: boolean
  isCardActivationEnabled: boolean
  isCardStatusTrackerEnabled: boolean
  isCBREnabled: boolean
  isChangePaymentDueDateEnabled: boolean
  isCobrowseEnabled: boolean
  isCreditBalanceRefundDrawerEnabled: boolean
  isCreditLimitIncreaseEnabled: boolean
  isCreditViewDashboardEnabled: boolean
  isCustomCardArtEnabled: boolean
  isDigitalCollectionsEnabled: boolean
  isDigitalCollectionsExperienceEnabled: boolean
  isDYEnabled: boolean
  isDYScriptEnabled: boolean
  isIRLEnabled: boolean
  isIvaEnabled: boolean
  isLateFeeDateEnabled: boolean
  isLoanNickNameModalEnabled: boolean
  isManageCardHolderEnabled: boolean
  isManageCardHolderSamsEnabled: boolean
  isManagePaymentMethodsEnabled: boolean
  isMarketingPrivacySettingEnabled: boolean
  isMarketPlaceEnabled: boolean
  isNotificationCenterEnabled: boolean
  isNotificationsEnabled: boolean
  isPaymentSecurityEnabled: boolean
  isProfileManagementEnabled: boolean
  isPromotionsMfeEnabled: boolean
  isReplaceYourCardEnabled: boolean
  isRewardsDeeplinkEnabled: boolean
  isSavingCheckingEnabled: boolean
  isShortTermCapEnabled: boolean
  isShowCookieSetting: boolean
  isStatementsDeeplinkEnabled: boolean
  isStatementsMfeEnabled: boolean
  isVantageScoreMfeEnabled: boolean
  isUPAGAutopaySectionEnabled: boolean
}

const prodFeatureFlags: FeatureFlagsType = {
  isAccountDetailsRouteEnabled: true,
  isAccountUpgradingMessageEnabled: false,
  isAddAccountEnabled: false,
  isCardActivationEnabled: false,
  isCardStatusTrackerEnabled: false,
  isCBREnabled: true,
  isChangePaymentDueDateEnabled: false,
  isCobrowseEnabled: true,
  isCreditBalanceRefundDrawerEnabled: false,
  isCreditLimitIncreaseEnabled: true,
  isCreditViewDashboardEnabled: true,
  isCustomCardArtEnabled: false,
  isDigitalCollectionsEnabled: false,
  isDigitalCollectionsExperienceEnabled: false,
  isDYEnabled: false,
  isDYScriptEnabled: false,
  isIRLEnabled: false,
  isIvaEnabled: true,
  isLateFeeDateEnabled: false,
  isLoanNickNameModalEnabled: false,
  isManageCardHolderEnabled: true,
  isManageCardHolderSamsEnabled: true,
  isManagePaymentMethodsEnabled: true,
  isMarketingPrivacySettingEnabled: true,
  isMarketPlaceEnabled: true,
  isNotificationCenterEnabled: false,
  isNotificationsEnabled: true,
  isPaymentSecurityEnabled: false,
  isProfileManagementEnabled: true,
  isPromotionsMfeEnabled: true,
  isReplaceYourCardEnabled: false,
  isRewardsDeeplinkEnabled: true,
  isSavingCheckingEnabled: false,
  isShortTermCapEnabled: false,
  isShowCookieSetting: false,
  isStatementsDeeplinkEnabled: true,
  isStatementsMfeEnabled: true,
  isVantageScoreMfeEnabled: true,
  isUPAGAutopaySectionEnabled: false
}

const localFeatureFlags: FeatureFlagsType = {
  isAccountDetailsRouteEnabled: true,
  isAccountUpgradingMessageEnabled: true,
  isAddAccountEnabled: true,
  isCardActivationEnabled: false,
  isCardStatusTrackerEnabled: true,
  isCBREnabled: true,
  isChangePaymentDueDateEnabled: true,
  isCobrowseEnabled: true,
  isCreditBalanceRefundDrawerEnabled: true,
  isCreditLimitIncreaseEnabled: true,
  isCreditViewDashboardEnabled: true,
  isCustomCardArtEnabled: true,
  isDigitalCollectionsEnabled: false,
  isDigitalCollectionsExperienceEnabled: true,
  isDYEnabled: true,
  isDYScriptEnabled: true,
  isIRLEnabled: true,
  isIvaEnabled: true,
  isLateFeeDateEnabled: false,
  isLoanNickNameModalEnabled: false,
  isManageCardHolderEnabled: true,
  isManageCardHolderSamsEnabled: true,
  isManagePaymentMethodsEnabled: true,
  isMarketingPrivacySettingEnabled: true,
  isMarketPlaceEnabled: true,
  isNotificationCenterEnabled: true,
  isNotificationsEnabled: true,
  isPaymentSecurityEnabled: true,
  isProfileManagementEnabled: true,
  isPromotionsMfeEnabled: true,
  isReplaceYourCardEnabled: true,
  isRewardsDeeplinkEnabled: true,
  isSavingCheckingEnabled: true,
  isShortTermCapEnabled: true,
  isShowCookieSetting: true,
  isStatementsDeeplinkEnabled: true,
  isStatementsMfeEnabled: true,
  isVantageScoreMfeEnabled: true,
  isUPAGAutopaySectionEnabled: false
}

const defaultFeatureFlags =
  NODE_ENV === 'production' ? prodFeatureFlags : localFeatureFlags

// To allow Cypress to inject featureFlags into window to mock the values

const runtimeFlags =
  typeof window !== 'undefined' &&
  (window as { featureFlags?: Partial<FeatureFlagsType> }).featureFlags
    ? (window as { featureFlags?: Partial<FeatureFlagsType> }).featureFlags
    : {}

const effectiveFeatureFlags: FeatureFlagsType =
  NODE_ENV !== 'production'
    ? { ...defaultFeatureFlags, ...runtimeFlags }
    : defaultFeatureFlags

export default effectiveFeatureFlags
